@switch (type) {
  @case ('new') {
    <span class="badge badge-new">
      <ng-container *ngTemplateOutlet="content" />
    </span>
  }
  @case ('grey') {
    <span class="badge badge-grey">
      <ng-container *ngTemplateOutlet="content" />
    </span>
  }
  @default {
    <span [class]="'badge badge-default ' + size">
      <ng-container *ngTemplateOutlet="content" />
    </span>
  }
}

<ng-template #content>
  <ng-content />
</ng-template>
